<template>
  <b-modal
    id="modal-add-body-part"
    hide-footer
    centered
    :noCloseOnBackdrop="false"
    :noCloseOnEsc="false"
    :hideHeaderClose="false"
    @hidden="resetModal"
  >
    <div class="col-12 d-flex flex-column align-items-center modalsTables">
      <h3><strong>Agregar parte del cuerpo</strong></h3>
      <div class="w-100 row mt-5">
        <div class="col-md-12 mb-4">
          <Select
            label="Frecuencia"
            name="frequency"
            :options="frecuencies"
            :value="formData.frequency"
            v-model="formData.frequency"
          />
        </div>
        <div class="col-md-12 mb-4">
          <Select
            label="Nivel"
            name="level"
            :options="levels"
            :value="formData.level"
            v-model="formData.level"
          />
        </div>
      </div>

      <div
        class="w-100 mt-4 d-flex align-content-center justify-content-center"
      >
        <button
          class="button-primary"
          style="color: white !important"
          :disabled="false"
          @click.prevent="addPart()"
        >
          Agregar
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import useInputs from "@/components/general/Inputs";
const { Select } = useInputs();
const { required } = require("vuelidate/lib/validators");
export default {
  components: {
    Select,
  },
  props: {
    levels: {
      type: Array,
      default: () => [],
    },
    frecuencies: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formData: {
        frequency: null,
        level: null,
      },
    };
  },
  validations: {
    formData: {
      frequency: {
        required,
      },
      level: {
        required,
      },
    },
  },
  methods: {
    addPart() {
      const me = this;
      me.$emit("addBodyPartsConfirm", me.formData);
      me.$bvModal.hide("modal-add-body-part");
    },
    resetModal() {
      const me = this;
      me.formData = {
        frequency: null,
        level: null,
      };
    },
  },
};
</script>
